import * as React from 'react';
import * as cost from './style.module.scss';
import { Modal } from '../../../../../Modal';
import { TaxDeduction } from '../../../../../TaxDeduction';
export const Cost = ({ widgetFull, accessText, sravni }) => {
  const [showModalFull, setShowModalFull] = React.useState(false);
  return (
    <section className={cost.cost} id="cost">
      <div className="container">
        <h3>Стоимость обучения</h3>
        <div className={cost.cost__blocks}>
          <div className={cost.cost__infoBlock}>
            <p className={cost.cost__infoText}>
              На курсе мы научим вас запоминать любую информацию быстро, качественно и надолго! Помните, что кто владеет
              информацией, тот владеет миром.
            </p>
            <ul>
              <li className={cost.cost__infoItem}>34 урока с домашним заданием и тестированием;</li>
              <li className={cost.cost__infoItem}>Поддержка куратора и&nbsp;преподавателя;</li>
              <li className={cost.cost__infoItem}>Общий чат учеников.</li>
            </ul>
          </div>
          <div className={cost.cost__pricesBlock}>
            <h4 className={cost.cost__pricesHeaderKrp}>Курс развития памяти и&nbsp;внимания</h4>

            <ul className={cost.cost__pricesList}>
              <li className={cost.cost__pricesItem}>{accessText || 'Доступ к курсу на\u00A01\u00A0год'}</li>
            </ul>

            <div className={cost.cost__pricesBuy}>
              <p className={cost.cost__pricesText}>При единовременной оплате</p>
              <p className={cost.cost__pricesPriceOld}>69&nbsp;900&nbsp;₽</p>
              <p className={cost.cost__pricesPriceKrp}>54&nbsp;900&nbsp;₽</p>
              <p className={cost.cost__pricesText}>В рассрочку на&nbsp;10&nbsp;месяцев</p>
              <p className={cost.cost__pricesPriceKrp}>
                5&nbsp;490&nbsp;₽<span className={cost.month}>/месяц</span>
              </p>
              <button
                className={cost.cost__pricesButtonKrp}
                onClick={() => {
                  setShowModalFull(true);
                }}
              >
                Купить курс
              </button>
            </div>
          </div>
        </div>

        <div className={cost.cost__undertext}>
          <p>Все наши курсы можно оплатить материнским капиталом</p>
        </div>
        <div className={cost.cost__undertext}>{sravni ? <TaxDeduction linkInner={true} /> : <TaxDeduction />}</div>
      </div>

      <Modal
        open={showModalFull}
        onClose={() => {
          setShowModalFull(false);
        }}
      >
        {widgetFull}
      </Modal>
    </section>
  );
};
